(function backgroundTaskDefinition() {

    'use strict';

    angular.module('BackgroundTask')
        .controller('BackgroundTaskController', [
            '$scope','fullTextProcessService','ocrProcessService', 'config', '$state', '$translate', 'errorsExtend', 'authExtend',
            function backgroundTaskController($scope, fullTextProcessService, ocrProcessService) {
                $scope.statusFullText = "NO INFO";
                $scope.statusFullTextEngine = "NO INFO";
                $scope.statusFullTextEngineVersion = "NO INFO";
                $scope.statusFullTextEngineOther = "NO INFO";
                $scope.statusOcr = "NO INFO";

                $scope.getStatusFullText = function () {
                    $scope.statusFullText = "NO INFO";

                    return fullTextProcessService.getStatus().then(function getOk(result) {
                        $scope.statusFullText = result;
                       

                    }, function getError(error) {
                        $scope.statusFullText = "ERROR";
                        errors.showError(error);
                    });

                };

                $scope.getStatusFullTextEngine = function () {
                    $scope.statusFullTextEngine = "NO INFO";
                    $scope.statusFullTextEngineVersion = "NO INFO";
                    $scope.statusFullTextEngineOther = "NO INFO";

                    return fullTextProcessService.getStatusEngine().then(function getOk(result) {
                        $scope.statusFullTextEngine = result.engine;
                        $scope.statusFullTextEngineVersion = result.version;
                        $scope.statusFullTextEngineOther = result.otherInfo;


                    }, function getError(error) {
                        $scope.statusFullTextEngine = "ERROR";
                        errors.showError(error);
                    });

                };

                $scope.runFullTextTask = function () {

                    return fullTextProcessService.runFullTextTask().then(function getOk(result) {
                        $scope.statusFullText = result;

                    }, function getError(error) {
                        $scope.statusFullText = "ERROR";
                        errors.showError(error);
                    });

                };

                $scope.removeFullTextTask = function () {

                    return fullTextProcessService.removeFullTextTask().then(function getOk(result) {
                        $scope.statusFullText = result;

                    }, function getError(error) {
                        $scope.statusFullText = "ERROR";
                        errors.showError(error);
                    });

                };

                $scope.addFullTextTask = function () {

                    return fullTextProcessService.addFullTextTask().then(function getOk(result) {
                        $scope.statusFullText = result;

                    }, function getError(error) {
                        $scope.statusFullText = "ERROR";
                        errors.showError(error);
                    });

                };


                //OCR
                $scope.getStatusOcr = function () {
                    $scope.statusOcr = "NO INFO";

                    return ocrProcessService.getStatus().then(function getOk(result) {
                        $scope.statusOcr = result;


                    }, function getError(error) {
                        $scope.statusOcr = "ERROR";
                        errors.showError(error);
                    });

                };

                $scope.addOcrTask = function () {

                    return ocrProcessService.addOcrTask().then(function getOk(result) {
                        $scope.statusOcr = result;

                    }, function getError(error) {
                        $scope.statusOcr = "ERROR";
                        errors.showError(error);
                    });

                };

                $scope.removeOcrTask = function () {

                    return ocrProcessService.removeOcrTask().then(function getOk(result) {
                        $scope.statusOcr = result;

                    }, function getError(error) {
                        $scope.statusOcr = "ERROR";
                        errors.showError(error);
                    });

                };


                $scope.runOcrTask = function () {

                    return ocrProcessService.runOcrTask().then(function getOk(result) {
                        $scope.statusOcr = result;

                    }, function getError(error) {
                        $scope.statusOcr = "ERROR";
                        errors.showError(error);
                    });

                };

                $scope.load = function () {
                  $scope.getStatusFullText();
                  $scope.getStatusFullTextEngine();
                  $scope.getStatusOcr();
                }

                $scope.load();
            }


        ]);
})();